export const CONTACT = {
  email: "contact@anuyora.com",
  phone: "+919968941798",
  phoneLabel: "+91 99689 41798",
  address: "Delhi, India",
};

export const NAV = [
  { to: "/services", label: "Services", id: "services" },
  { to: "/how-we-work", label: "How We Work", id: "how-we-work" },
  { to: "/about", label: "About", id: "about" },
  { to: "/contact", label: "Contact", id: "contact" },
];